import { normalize } from 'normalizr';

import { callApi, pageToOffsetParams } from 'utils/api';
import { findRowByCommentsOwnerType } from 'commentsResourceTypes';
import * as schemas from 'schemas';

export function searchItemsFetch(page, query) {
  let resourceTypes = '';
  if (query.category === 'magazine') resourceTypes = findRowByCommentsOwnerType('article');
  if (query.category === 'forum') resourceTypes = findRowByCommentsOwnerType('forumThread');

  return callApi('/search', {
    query: {
      ...pageToOffsetParams(page, process.env.KOOTH_PAGE_SIZE),
      term: query.term,
      resourceTypes
    }
  })
  .then(json => {
    const { results, meta } = json;

    const searchResults = normalize(results, schemas.searchResultsArraySchema);

    return { searchResults, meta };
  });
}



/** WEBPACK FOOTER **
 ** ./src/members/state/search/api.js
 **/